'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.submitAnalyticsAction = submitAnalyticsAction;
exports.trackAnalytic = trackAnalytic;
exports.manualTrack = manualTrack;

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _AnalyticService = require('helpers/AnalyticService');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { localStore } from '../../utils/localStorage';
var SUBMIT = 'lookme/analytics/SUBMIT';
// import AnalyticService from 'helpers/AnalyticService';

var SUBMIT_SUCCESS = 'lookme/analytics/SUBMIT_SUCCESS';
var SUBMIT_FAIL = 'lookme/analytics/SUBMIT_FAIL';
var TRACK_ANALYTIC = 'lookme/analytics/TRACK_ANALYTIC';

//
// const routeToScreenName = {
//   'dang-nhap': {},
//   'kham-pha': { screen: 'Search' },
//   'cham-soc-da-massage': {},
//   'lam-toc-mong': {},
//   'tham-my-vien': {},
//   'phong-kham': {},
//   'the-duc-the-thao': {},
//   'xam-hinh': {},
//   'salon-mi-va-mong': {},
//   'spa-cham-da': {},
//   'massage-va-goi-dau': {},
//   'tham-my-va-nha-khoa': {},
//   'salon-toc-va-make-up': {},
//   'dich-vu-tai-nha': {},
//   uudai: {},
//   'uu-dai': {},
//   'uu-dai-tai-nha': {},
//   'uu-dai-tai-spa': {},
//   'uu-dai-trai-nghiem': {},
//   'uu-dai-5-sao': {},
//   'uu-dai-toi': {},
//   'uu-dai-goi/:campaignHandle': {},
//   'voucher-detail/:voucherId': {},
//   'uu-dai-cham-soc-da-massage': {},
//   'uu-dai-lam-toc-mong': {},
//   'uu-dai-tham-my-vien': {},
//   'uu-dai-phong-kham': {},
//   'uu-dai-the-duc-the-thao': {},
//   'uu-dai-xam-hinh': {},
//   'uu-dai-dich-vu-tai-nha': {},
//   'uu-dai/:handle': {},
//   'uu-dai-doi-tac': {},
//   'huong-dan-doi-tac': {},
//   'kol/:code': {},
//   'uu-dai-cua-toi/:code': {},
//   'chinh-sach': {},
//   'thong-tin-lien-he': {},
//   'quy-che-hoat-dong': {},
//   'giai-quyet-tranh-chap': {},
//   'bao-mat': {},
//   ':query': {},
//   'dat-lich': { screen: 'Booking' },
//   'dat-lich-2': { screen: 'Step Two' },
//   'dat-lich-3': { screen: 'Step Three' },
//   'lich-hen': { screen: 'ManageBooking' },
//   'quan-ly-dat-cho': {},
//   'lich-hen/:bookingRequestId': {},
//   'tai-khoan': { screen: 'Account' },
//   'lich-su-hoat-dong': {},
//   history: {},
//   'chinh-sua-tai-khoan': {},
//   'quan-ly-uu-dai': {},
//   'thong-bao': { screen: 'Notification' },
//   'gop-y': {},
//   'quyen-loi-thanh-vien': {},
//   'lich-su-nap-tien': {},
//   'phuong-thuc-thanh-toan': {},
//   '/bo-suu-tap': {},
//   '/bo-suu-tap/:handle': {},
//   'khuyen-mai/:id': {},
//   ':shopHandle/viet-danh-gia': {},
//   'tao-cua-hang': {},
//   'chat/:shopHandle': {},
//   ':shopHandle/danh-gia': {},
//   'shop/:id': {},
//   ':id': {},
//   'dich-vu/:handle': {},
//   'thong-tin-shop/:id': {},
// };
// console.log('ROUTE TO SCREEN NAME', routeToScreenName);
//
var initialState = {
  ANALYTIC_EXTRA: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SUBMIT:
      return state;
    case SUBMIT_SUCCESS:
      console.log('action', action);
      return (0, _extends3.default)({}, state, {
        ANALYTIC_EXTRA: (0, _extends3.default)({}, state.ANALYTIC_EXTRA, {
          analytic: action.result._id
        })
      });
    case SUBMIT_FAIL:
      _reactGa2.default.event({
        category: 'Lookme_Analytics',
        action: 'Submit',
        label: '' + action.error.message
      });
      return state;
    case TRACK_ANALYTIC:
      return state;
    default:
      return state;
  }
}

function submitAnalyticsAction(dataAnalytics) {
  return {
    types: [SUBMIT, SUBMIT_SUCCESS, SUBMIT_FAIL],
    promise: function promise(client) {
      return client.post('/analytics/submitAnanlyticsForApp', {
        jsonData: dataAnalytics
      });
    }
  };
}

function trackAnalytic(analyticId) {
  return {
    type: TRACK_ANALYTIC,
    data: {
      analytic: analyticId
    }
  };
}

function manualTrack(trackData) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var store, track, user, coords;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store = getState();
              track = (0, _extends3.default)({}, trackData);
              user = store.auth.user, coords = store.user.coords;


              console.log('single tree', store);
              if (coords && typeof coords.latitude === 'number' && typeof coords.longitude === 'number') {
                track.geo = {
                  lat: coords.latitude,
                  lng: coords.longitude
                };
              }
              track.userId = user ? user._id : '';
              (0, _AnalyticService.manualTrack)(track);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }();
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/analytics.js
// module id = 110
// module chunks = 0